import styled from 'styled-components'

export const NewProductContent = styled.div``
